import '../livesearch/jquery.live-search';
import $ from "jquery";




$(document).ready(function() {

    //LIVESEARCH
    const container = $("[js-filter-list]");

    container.liveSearch({
        path: ajaxPath,
        resultsContainer: "[js-filter-destination]",
        paginationContainer: ".pagination",
        filters: '.criterion',
        reset: "[js-reset-filter]",
        useLive: true,
        perPage: 12,
        render: function (item) {
            if('string' === typeof item){
                return item;
            }
        }
    });

    container.on("livesearch.rendered", function (event, data) {
        $('[js-filter-loading-layout]').hide();

        if (data.items && data.items.length) {
            $("[js-filter-no-result]").hide();
        } else {
            $("[js-filter-no-result]").css({'visibility': 'visible', 'display': 'block'});
        }
    });

    container.on("livesearch.beforeSearch", function () {
        $("[js-filter-no-result]").css({'visibility': 'hidden', 'display': 'none'});
    });


});



// WEBPACK FOOTER //
// ./assets/scripts/pages/archive-filter.js